var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 13C6.17157 13 5.5 13.6716 5.5 14.5C5.5 15.3284 6.17157 16 7 16C7.82843 16 8.5 15.3284 8.5 14.5C8.5 13.6716 7.82843 13 7 13ZM3.5 14.5C3.5 12.567 5.067 11 7 11C8.933 11 10.5 12.567 10.5 14.5C10.5 16.433 8.933 18 7 18C5.067 18 3.5 16.433 3.5 14.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 13C16.1716 13 15.5 13.6716 15.5 14.5C15.5 15.3284 16.1716 16 17 16C17.8284 16 18.5 15.3284 18.5 14.5C18.5 13.6716 17.8284 13 17 13ZM13.5 14.5C13.5 12.567 15.067 11 17 11C18.933 11 20.5 12.567 20.5 14.5C20.5 16.433 18.933 18 17 18C15.067 18 13.5 16.433 13.5 14.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C11.1716 3 10.5 3.67157 10.5 4.5C10.5 5.32843 11.1716 6 12 6C12.8284 6 13.5 5.32843 13.5 4.5C13.5 3.67157 12.8284 3 12 3ZM8.5 4.5C8.5 2.567 10.067 1 12 1C13.933 1 15.5 2.567 15.5 4.5C15.5 6.433 13.933 8 12 8C10.067 8 8.5 6.433 8.5 4.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 22C1 18.6863 3.68629 16 7 16C10.3137 16 13 18.6863 13 22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22C11 19.7909 9.20912 18 7 18C4.79086 18 3 19.7909 3 22C3 22.5523 2.55228 23 2 23C1.44772 23 1 22.5523 1 22Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 22C11 18.6863 13.6863 16 17 16C20.3137 16 23 18.6863 23 22C23 22.5523 22.5523 23 22 23C21.4477 23 21 22.5523 21 22C21 19.7909 19.2091 18 17 18C14.7909 18 13 19.7909 13 22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12C6 8.68632 8.68632 6 12 6C15.3137 6 18 8.68632 18 12C18 12.5523 17.5523 13 17 13C16.4477 13 16 12.5523 16 12C16 9.79088 14.2091 8 12 8C9.79088 8 8 9.79088 8 12C8 12.5523 7.55228 13 7 13C6.44772 13 6 12.5523 6 12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff);
export default __webpack_public_path__ + "static/media/staff.120a03d15c8fa3396bfcbc67bcce7798.svg";
export { ForwardRef as ReactComponent };